import { render } from "./Editor1.vue?vue&type=template&id=3f2b5f60&scoped=true"
import script from "./Editor1.vue?vue&type=script&lang=js"
export * from "./Editor1.vue?vue&type=script&lang=js"

import "./Editor1.vue?vue&type=style&index=0&id=3f2b5f60&lang=scss&scoped=true"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3f2b5f60"]])

export default __exports__